/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDetailsPageEvent, useAppDetailsPageDataSelector } from ".";
import { LoadingStatus } from "../../../rootReducer/actions";
import LoaderPage from "../../Common/LoaderPage";
import AppDetailsView from "./AppDetails";
import ReviewsSummary from "../Reviews/ReviewsSummary";
import AppSuggestions from "../../Common/AppSuggestions";
import AddReviewModal from "../Reviews/AddReviewModal";
import { useMainPageDataSelector } from "../../MainUi";
import ErrorPage from "../ErrorPage";

export default function AppDetailsPage() {
  const dispatch = useDispatch();
  const pageData = useAppDetailsPageDataSelector();
  const mainPageData = useMainPageDataSelector();

  const parameters: {
    appId?: string;
  } = useParams();

  useEffect(() => {
    if (!pageData.addingReview) {
      dispatch({
        type: AppDetailsPageEvent.GET_APP_DETAILS_PAGE_DATA,
        appId: parameters.appId,
        msisdn: mainPageData.appUser.msisdn
          ? mainPageData.appUser.msisdn
          : null,
      });
    }
    if (!mainPageData.subscribing) {
      dispatch({
        type: AppDetailsPageEvent.GET_APP_DETAILS_PAGE_DATA,
        appId: parameters.appId,
        msisdn: mainPageData.appUser.msisdn
          ? mainPageData.appUser.msisdn
          : null,
      });
    }
    return () => {
      // cleanup
      dispatch({
        type: AppDetailsPageEvent.RESET_APP_DETAILS_PAGE_DATA,
      });
    };
  }, [
    dispatch,
    parameters.appId,
    mainPageData.authState,
    pageData.addingReview,
    mainPageData.subscribing,
    mainPageData.appUser.msisdn,
  ]);

  return (
    <div>
      <Helmet>
        <meta property="og:url" content={document.URL} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageData.appDetails?.name} />
        <meta
          property="og:description"
          content={pageData.appDetails?.summarizedDescription}
        />
        <meta property="og:image" content={pageData.appDetails?.appLogo} />
      </Helmet>
      {pageData.showAddReviewModal && (
        <AddReviewModal
          appId={pageData.appDetails ? pageData.appDetails?.appId : ""}
        />
      )}
      {pageData.loadingStatus === LoadingStatus.LOADING_SUCCESS ? (
        <div className="container mt-sm-5 mt-0">
          {pageData.appDetails && <AppDetailsView app={pageData.appDetails} />}
          {pageData.appDetails && pageData.reviews && <ReviewsSummary reviews={pageData.reviews} />}
          {pageData.suggestedApps && pageData.suggestedApps.length > 0 && (
            <AppSuggestions
              title="From Developer"
              apps={pageData.suggestedApps}
            />
          )}
        </div>
      ) : pageData.loadingStatus === LoadingStatus.LOADING_STARTED ? (
        <LoaderPage />
      ) : (
        <ErrorPage />
      )}
    </div>
  );
}
